import * as S from './Button.styles';
import Tooltip from '../ReactTooltip/Tooltip';
import { v4 as uuid } from 'uuid';
import { useMemo } from 'react';

interface ICopyButtonProps {
    onClick: () => void;
}

const CopyButton = ({ onClick }: ICopyButtonProps) => {
    const tooltipId = useMemo(() => uuid(), []);
    return (
        <Tooltip text="Copy" tooltipId={tooltipId}>
            <S.IconWrapper onClick={onClick} data-tip data-for={tooltipId}>
                <S.SSOCopyIcon/>
            </S.IconWrapper>
        </Tooltip>
    );
};

export default CopyButton;
